// extracted by mini-css-extract-plugin
export var autoSuggestion = "styles-module--autoSuggestion--71656";
export var autoSuggestionContent = "styles-module--autoSuggestionContent--1bb99";
export var autoSuggestionTitle = "styles-module--autoSuggestionTitle--551e6";
export var backdrop = "styles-module--backdrop--0a720";
export var closeBtn = "styles-module--closeBtn--ffff3";
export var closeIcon = "styles-module--closeIcon--baef2";
export var isActive = "styles-module--isActive--25bd5";
export var search = "styles-module--search--096d5";
export var searchBtn = "styles-module--searchBtn--a3728";
export var searchField = "styles-module--searchField--4c390";
export var searchIcon = "styles-module--searchIcon--b495f";
export var searchInput = "styles-module--searchInput--fdc53";
export var small = "styles-module--small--ae849";